export class paginationConfig {
  currentPage:number= 1;
  itemsPerPage:number= 5;
  totalItems:number=0;
}
